import {
  MODAL_INTERACTION,
  MODAL_HIDDEN,
  MODAL_DATA_LOADED,
  COLUMNS_ROWS_LOADED,
  LOADING,
} from '../actions/constants';
import { buildDataTable } from './rows';
import ModalSelect from '../components/modals/ModalSelect';
import { SELECT } from '../util/enums/EnumLayers';
import Column from '../util/Column';
import ColumnName from '../util/ColumnName';

const INITIAL_STATE = {
  visible: [], // ColumnName objs
  results: null, // DataTable representing results
  readyForSave: false,
};

function containsColumnName(list, columnName) {
  return list.findIndex((cn) => cn.equals(columnName)) !== -1;
}

function interaction(state, payload) {
  switch (payload.section) {
    case 'selectAll':
      return { ...state, visible: payload.columns.map((c) => c.name()) };
    case 'selectNone':
      return { ...state, visible: [] };
    case 'toggleColumn': {
      const addColumn = !containsColumnName(state.visible, payload.columnName);
      if (addColumn) {
        // add column to selected list
        return {
          ...state,
          visible: payload.columns
            .filter(
              (c) =>
                c.name().equals(payload.columnName) ||
                containsColumnName(state.visible, c.name()),
            )
            .map((c) => c.name()),
        };
      }
      // remove column from selected list
      return {
        ...state,
        visible: state.visible.filter((c) => !c.equals(payload.columnName)),
      };
    }
    default:
      return state;
  }
}

const modalSelect = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOADING: {
      if (action.awaiting === COLUMNS_ROWS_LOADED) {
        return {
          ...state,
          results: null, // reset
        };
      }
      return state;
    }
    case COLUMNS_ROWS_LOADED: {
      return { ...state, results: buildDataTable(action.payload.json) };
    }
    case MODAL_INTERACTION: {
      if (action.payload.modalType !== SELECT) {
        return state;
      }
      const newState = interaction(state, action.payload.props);
      newState.readyForSave = newState.visible.length > 0;
      return newState;
    }
    case MODAL_HIDDEN:
      return INITIAL_STATE; // reset modal
    case MODAL_DATA_LOADED:
      if (action.payload.modal === ModalSelect) {
        const columns = action.payload.json.map((c) => Column.build(c));
        const invertSelection =
          action.payload.additionalOptions &&
          action.payload.additionalOptions.invertSelection;
        if (action.payload.existingLayer) {
          // user is editing an existing 'columns' layer
          const columnNames = action.payload.existingLayer
            .columnNames()
            .filter(
              (cn) => columns.findIndex((c) => c.name().equals(cn)) !== -1,
            );
          return {
            ...state,
            visible: columnNames,
            readyForSave: columnNames.length > 0,
          };
        }
        // new columns layer
        let visibleColumns = action.payload.selectedColumns.map((c) =>
          ColumnName.build(c),
        );
        if (action.payload.relevantColumnName) {
          const visibleCondition = (cn) =>
            invertSelection
              ? cn.equals(action.payload.relevantColumnName)
              : !cn.equals(action.payload.relevantColumnName);
          visibleColumns = visibleColumns.filter(visibleCondition);
        }
        return { ...state, visible: visibleColumns, readyForSave: true };
      }
      return state;
    default:
      return state;
  }
};

export default modalSelect;
